import React from 'react';
import PropTypes from 'prop-types';

import icons from '../../utils/assets/icons';

import CustomIconButton from '../CustomIconButton';

const ACTION_TYPES = {
  cancel: {
    img: icons.x,
    desc: 'Cancel',
  },
  confirm: {
    img: icons.check,
    desc: 'Confirm',
  },
  delete: {
    img: icons.delete,
    desc: 'Delete',
  },
  edit: {
    img: icons.edit,
    desc: 'Edit',
  },
  send: {
    img: icons.send,
    desc: 'Send',
  },
};

export default function IconButton({ onClick, icon }) {
  const { img, desc } = ACTION_TYPES[icon];

  return <CustomIconButton onClick={onClick} src={img} alt={desc} title={desc} />;
}

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.oneOf(['confirm', 'edit', 'delete', 'send', 'cancel']),
};

IconButton.defaultProps = {
  icon: 'confirm',
};
